import Button from '@/trio-ui/Button';
import TransparentButton from '@/trio-ui/TransparentButton';
import { InterviewReviewType, TechnicalValidationCompetency } from '@/types/api';
import { TECHNICAL_VALIDATION_COMPETENCIES } from '@/utils/interviews';
import * as Styles from './TechnicalValidationReviewsManager.styles';
import FinalScore from '../FinalScore';
import TechnicalValidationReview from '../TechnicalValidationReview';

export type CustomReviewType = Partial<
  InterviewReviewType & {
    isEditing: boolean;
    isExpanded: boolean;
    competencies: TechnicalValidationCompetency[];
  }
>;

type TechnicalValidationReviewsManagerComponentProps = {
  canAddFirstReview: boolean;
  canAddNewReview: boolean;
  reviews: CustomReviewType[];
  isActionLoading: boolean;
  finalScore?: string;
  reviewsResult?: string;
  onAddNewReview: (event: any) => void;
  onCancelAddNewInterviewReview: (interviewReviewIndex: number) => void;
  onAddNewInterviewReview: (index: number, newReview: CustomReviewType) => Promise<boolean>;
  onDeleteInterviewReview: (interviewReviewId: string) => Promise<boolean>;
};

export default function TechnicalValidationReviewsManagerComponent({
  canAddFirstReview,
  canAddNewReview,
  reviews,
  finalScore,
  reviewsResult,
  isActionLoading,
  onAddNewReview,
  onCancelAddNewInterviewReview,
  onAddNewInterviewReview,
  onDeleteInterviewReview,
}: TechnicalValidationReviewsManagerComponentProps): JSX.Element {
  const EmptyComponent = canAddFirstReview ? (
    <Styles.Centered>
      <Button onClick={onAddNewReview}>Add review</Button>
    </Styles.Centered>
  ) : (
    <Styles.EmptyMessage>There’re no answers to be reviewed yet.</Styles.EmptyMessage>
  );

  return (
    <div>
      <Styles.Title>Reviews</Styles.Title>

      {canAddNewReview ? (
        <>
          {reviews?.map((review, index) => {
            return (
              <TechnicalValidationReview
                isActionLoading={isActionLoading}
                key={`${review.id}-${index.toString()}`}
                onDelete={onDeleteInterviewReview}
                onSave={onAddNewInterviewReview}
                onCancel={onCancelAddNewInterviewReview}
                index={index}
                id={review.id}
                reviewer={review.user}
                reviewedAt={review.updatedAt}
                competencies={review.competencies ?? TECHNICAL_VALIDATION_COMPETENCIES}
                overviewNote={review.note}
              />
            );
          })}

          <TransparentButton onClick={onAddNewReview} isBlueButton>
            + New Review
          </TransparentButton>

          {!!finalScore && <FinalScore scoreLabel={finalScore} resultLabel={reviewsResult} />}
        </>
      ) : (
        EmptyComponent
      )}
    </div>
  );
}
